<template>
  <div>
    <div class="population-selector-component">
      <div class="preset-column">
        <input-container v-model="fieldConfig[1]" :showTooltip="true"></input-container>
        <a class="create-new-population" @click="createNewPopulation()">
          + Create new population
        </a>
        <input-container id="disabled" v-model="fieldConfig[3]" :showTooltip="true"
          class="cardiac-cycle"></input-container>
      </div>
      <div class="basis-column">
        <div class="label">Population Information <span class="field-info"
            v-tooltip="'Population description and parameters'"></span></div>
        <div class="population-disclaimer">This population was derived from a <b>single heart anatomy</b>, results can
          provide valuable trend information and insights but they will not fully represent the diversity of real-world
          populations.</div>
        <div class="info-box" v-if="selectedPopulation in populationsInfo">
          <div class="descriptors">
            <div class="item" v-for="descriptor in populationDescriptors"> {{ descriptor }}</div>
          </div>
          <div class="infos">
            <div class="item" v-for="info, i in populationsInfo[selectedPopulation]">{{ info }}</div>
          </div>
        </div>
        <div class="info-box" v-else>
          <p class="error">* Information not available for the selected population</p>
        </div>
      </div>
      <div class="size-column">
        <!-- Occupy right space -->
      </div>
    </div>
    <modal-create-population name="create-population"
      @populationCreated="onPopulationCreated"></modal-create-population>
  </div>
</template>

<script>
import ApolloAPI from '@/api/apollo_api';
import MultiSelectComponent from '@/components/MultiSelectComponent'
import ToggleInput from '@/components/inputs/frontendInputs/ToggleInput'
import InputContainer from '@/components/inputs/InputContainer'
import SubFieldListInputContainer from '@/components/inputs/SubFieldListInputContainer'
import ModalCreatePopulation from '@/components/modals/ModalCreatePopulation'


export default {
  name: 'PopulationSelectorComponent',
  components: { MultiSelectComponent, ToggleInput, InputContainer, SubFieldListInputContainer, ModalCreatePopulation },
  props: {
    fieldConfig: Array
  },
  model: {
    prop: 'fieldConfig',
    event: 'change'
  },
  mounted() {
    this.loadApolloPopulations();
  },
  data() {
    return {
      error: '',
      populationDescriptors: ['Phenotype', 'Female ratio', 'Anatomy count', 'BMI class.', 'Scar'],
      populationsInfo: {
        'T1.0 - 16  (16)': ['Healthy', '0.5', '1', 'Underweight', 'No'],
        'T1.0 - 32  (32)': ['Healthy', '0.5', '1', 'Underweight', 'No'],
        'T1.0 - 64  (64)': ['Healthy', '0.5', '1', 'Underweight', 'No'],
        'Teletubbie Population  (2)': ['Healthy', '0.5', '1', 'Explosive', 'No'],
      },
    }
  },
  computed: {
    selectedPopulation() {
      return this.fieldConfig[1].value
    },
  },
  methods: {
    loadApolloPopulations() {
      return new Promise((resolve, reject) => {
        ApolloAPI.getApolloPopulations().then(response => {
          let populationWidget = this.fieldConfig[1].view;

          const populations = response.data;
          let populationNames = [];
          populations.forEach(population => {
            populationNames.push(population.name + "  (" + population.number_of_subjects + ")");
          });
          populationWidget.validate_items = populationNames;
          resolve();

        }, error => {
          console.log("Error retrieving Apollo populations:");
          console.log(error);
          reject(error);
        });
      });
    },
    createNewPopulation() {
      this.$modal.show('create-population', {})
    },
    onPopulationCreated(populationName) {
      this.$modal.hide('create-population');
      this.loadApolloPopulations().then(() => {
        const selectOptions = this.fieldConfig[1].view.validate_items;
        this.fieldConfig[1].value = [selectOptions[selectOptions.length - 1]]; // Select new population in widget
      });

    }
  }
}
</script>

<style lang="stylus">
.population-selector-component
    display: flex
    flex-direction: row
    justify-content: space-between

    #disabled
        opacity: 0.4
        pointer-events: none

    .label
        color: $shuttle-gray
        display: flex
        align-items: center
        m-font-size(12, 14)
        margin-bottom: 5px
        .field-info
            margin-left: 5px
            m-icon('info', 14)
    .preset-column
        width: 20%
        flex-grow: 0
    .basis-column
        width: 40%
        padding-top: 5px
        .info-box
            margin-top: 10px
            background-color: white
            padding: 10px
            margin-bottom: 20px
            m-font-size(12,14)
            color: $cloud-burst
            border-radius: 5px
            box-shadow: 5px 5px 20px rgba($lynch, 0.25)
            display: flex
            flex-direction: row
            .descriptors
                font-weight: bold
                margin-right: 30px
            .item
                padding-bottom: 5px
            .error
              color: $mulberry
        .population-disclaimer
            m-font-size(12,14)
            color: $cloud-burst
    .size-column
        width: 20%
        padding-top: 5px
        .size-box
            margin-top: 10px
            margin-bottom: 22px

    .create-new-population
      m-font-size(12,14)
      color: $cloud-burst
      padding: 0 10px 20px 10px

      &:hover
        cursor: pointer
        text-decoration: underline

    .input-container.edit
      margin-bottom: 0px
    
    .input-container.cardiac-cycle
      margin-top: 10px
</style>